module.exports = __webpack_public_path__ + "static/media/word_icon.a78b68bd.png";